module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ScreenLayout', [_c('div', {
    staticClass: "pa-10 white ma-7 elevation-3",
    staticStyle: {
      "position": "relative",
      "xbackground-color": "rgba(0,0,0,0.0)"
    }
  }, [_c('FormControl', {
    attrs: {
      "schema": _vm.sampleSchema
    },
    on: {
      "change": _vm.formChanged
    },
    model: {
      value: (_vm.sampleRecord),
      callback: function($$v) {
        _vm.sampleRecord = $$v
      },
      expression: "sampleRecord"
    }
  })], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "right"
    },
    slot: "right"
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0ecbd30a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/forms/Sample.vue
// module id = 2449
// module chunks = 1